/**
 * Junk folder names that should be excluded from uploads.
 * These are common "build artifact" or "dependency" directories
 * that developers never want to back up.
 */
export const JUNK_PATTERNS: string[] = [
  "node_modules",
  ".svn",
  ".hg",
  ".venv",
  "venv",
  ".conda",
  "__pycache__",
  ".pytest_cache",
  ".mypy_cache",
  ".ruff_cache",
  ".eggs",
  ".ipynb_checkpoints",
  "dist",
  "build",
  "out",
  ".next",
  ".nuxt",
  ".turbo",
  ".cache",
  ".parcel-cache",
  "coverage",
  ".nyc_output",
  ".tox",
  ".terraform",
  ".serverless",
  "target", // Rust/Java build output
  "Pods",   // iOS CocoaPods
  ".gradle",
  ".idea",
  ".DS_Store",
  "Thumbs.db",
];

export interface FilterResult {
  isJunk: boolean;
  reason?: string;
}

/**
 * Check if a file path segment should be excluded.
 * Checks each path component against JUNK_PATTERNS.
 */
export function shouldExclude(relativePath: string): FilterResult {
  const parts = relativePath.replace(/\\/g, "/").split("/");

  for (const part of parts) {
    if (JUNK_PATTERNS.includes(part)) {
      return { isJunk: true, reason: `Contains "${part}" directory` };
    }
    // Hidden files/dirs (except ones users might want to keep)
    if (part.startsWith(".") && part !== ".env" && part !== ".htaccess" && part !== ".git") {
      if (part.endsWith(".lock") || part.includes("cache") || part.includes("git")) {
        return { isJunk: true, reason: `Hidden junk directory: "${part}"` };
      }
    }
  }

  return { isJunk: false };
}
